export enum NetworkTestType {
  PING = 'ping',
  TRACEROUTE = 'traceroute'
}
